import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08e58ec6")

_pushScopeId("data-v-08e58ec6")
const _hoisted_1 = { class: "flex top-button-group" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增分组", -1)
const _hoisted_3 = {
  class: "flex",
  style: {"align-items":"center","justify-content":"center"}
}
const _hoisted_4 = { class: "flex flexR mar-t-22" }
const _hoisted_5 = {
  key: 0,
  class: "menu"
}
const _hoisted_6 = { class: "parent" }
const _hoisted_7 = { class: "child mar-t-12" }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "确定", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "取 消", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        class: "bg-red mar-l-18 mar-t-12",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.addClick()))
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: $setup.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": $setup.headClass
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128)),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "200"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", {
                  class: "btn-red-line mar-l-8",
                  onClick: ($event: any) => ($setup.editClick(scope.row))
                }, " 编辑 ", 8, ["onClick"]),
                _createVNode("div", {
                  class: "btn-red-line mar-l-8",
                  onClick: ($event: any) => ($setup.deleteClick(scope.row))
                }, _toDisplayString(scope.row.status == 1 ? '禁用' : '启用'), 9, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, $setup.loading]
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_pagination, {
          onSizeChange: $setup.handleSizeChange,
          onCurrentChange: $setup.handleCurrentChange,
          "current-page": $setup.currentPage,
          "page-sizes": [10, 20,50,100],
          "page-size": $setup.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: $setup.total
        }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "编辑",
      "model-value": $setup.dialog_show == 'add' || $setup.dialog_show == 'edit',
      center: "",
      width: 1000,
      "before-close": ()=>{$setup.dialog_show = ''}
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: $setup._submitForm
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.dialog_show = ''))
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: $setup.form,
          ref: "formRef",
          inline: true
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "name",
              "label-width": "100px",
              rules: [
                        {
                            required: true,
                            message: '必填',
                            trigger: 'blur',
                        },
                    ]
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.form.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.form.name = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.form.projects, (item, index) => {
          return (_openBlock(), _createBlock(_Fragment, { key: index }, [
            (item.children.length>0)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, _toDisplayString(item.project_name), 1),
                  _createVNode("div", _hoisted_7, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: child.id,
                        modelValue: child.type,
                        "onUpdate:modelValue": ($event: any) => (child.type = $event),
                        "true-label": 1,
                        "false-label": 0
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(child.project_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value", "before-close"])
  ], 64))
})